export const sendNotification = (title, body) => {
  if (hasNotificationPermission()) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification(title, {
        body: body,
        icon: "../assets/images/logo.png",
        vibrate: [200, 100, 200, 100, 200, 100, 200],
      });
    });
  }
};

export const requestNotificationPermission = async () => {
  const result = await Notification.requestPermission();

  return result === "granted";
};

export const hasNotificationPermission = async () => {
  return Notification.permission === "granted";
};
